import React from "react";
import { bool, node, oneOf, string } from "prop-types";
import Section from "../Section";
import { Container, Row } from "../Grid";
import { classes } from "../utils/classes";

const GuidePageTemplate = ({ type = "guide", wrapperClassName = "", sidebar = true, children }) => {
	return (
		<Section
			className={classes(
				"guide-page-template",
				`guide-page-template-type-${type}`,
				wrapperClassName,
			)}
		>
			<Container>
				<Row px center={!sidebar}>
					{children}
				</Row>
			</Container>
		</Section>
	);
};

GuidePageTemplate.propTypes = {
	type: oneOf(["guide", "tutorial"]),
	wrapperClassName: string,
	sidebar: bool,
	children: node.isRequired,
};

export default GuidePageTemplate;
